import React, { useEffect, useState } from 'react';
import styles from './SpecialList.module.less';
import classNames from 'classnames';
import InfinteScroll from '../../components/InfinteScroll/GridInfinteScroll';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import SpecialCard from '../../components/SpecialCard/SpecialCard';
import {
  deleteCollectSpecial,
  getSpecialCollectList,
  updateSpecialCollectList,
} from '../../actions/collection';
import { useActivate, useAliveController } from 'react-activation';
import { useHistory, Link } from 'react-router-dom';
import { CONTEXT } from '../../config';
import Dialog from '../../components/Dialog/Dialog';
import Btn from '../../components/Btn/Btn';
import nodata from '../../static/collect_blank.svg';
import Loading from '../../components/Loading/Loading';
import { logging } from '../../actions/log';

const selectCollectList = createSelector(
  state => state.collection,
  collection => collection,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default ({ loginStatus }) => {
  const [ztInfo, setZtInfo] = useState(null);
  const dispatch = useDispatch();
  const {
    collectSpecialList: { list, pagenation },
    loading,
  } = useSelector(selectCollectList);
  const [modalVisible, setModalVisible] = useState(false);
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const { dropScope } = useAliveController();

  const getData = ({ refresh }) => {
    // eslint-disable-next-line no-nested-ternary
    const skip = refresh ? 0 : list && list.length;
    dispatch(
      getSpecialCollectList({
        refresh,
        skip,
        limit: 24,
      }),
    );
  };
  useActivate(() => {
    if (history === 'PUSH') {
      getData({
        refresh: true,
      });
    }
  }, []);
  useEffect(() => {
    if (loginStatus) {
      getData({
        refresh: true,
      });
    } else {
      dispatch(
        updateSpecialCollectList({
          error: false,
          list: [],
          code: 200500,
          refresh: true,
          limit: 24,
        }),
      );
    }
  }, [loginStatus]);
  const loadMore = () => {
    getData({
      refresh: false,
    });
  };

  const handleClick = zt => {
    dropScope('special');
    const timer = setTimeout(() => {
      history.push(`${CONTEXT}/special?ztId=${zt.ztId}&bizInfo=${zt.bizInfo}`);
      clearTimeout(timer);
    }, 50);
  };

  const handleDeleteModal = (visible, source) => (zt = null) => {
    setZtInfo(zt);
    setModalVisible(visible);
    // 确认弹窗展示
    if (visible) {
      dispatch(
        logging({
          category: 'P',
          action: 'Mysofts_Collect_Cancel',
          label: '',
          param2: {
            source: 'Mysofts_Collect',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: zt && zt.ztId,
          },
        }),
      );
    } else if (source === 'btn') {
      dispatch(
        logging({
          category: 'C',
          action: 'Mysofts_Collect_Cancel_N',
          label: '',
          param2: {
            source: 'Mysofts_Collect',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: ztInfo && ztInfo.ztId,
            type: 'zt',
          },
        }),
      );
    }
  };
  const handleDelete = () => {
    dispatch(
      deleteCollectSpecial({
        targetType: 'zt',
        targetId: ztInfo.ztId,
        source: 'list',
      }),
    );
    handleDeleteModal(false)();
    // 弹窗确认点击
    dispatch(
      logging({
        category: 'C',
        action: 'Mysofts_Collect_Cancel_Y',
        label: '',
        param2: {
          source: 'Mysofts_Collect',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id: ztInfo && ztInfo.ztId,
        },
      }),
    );
  };
  // 加载中
  if (loading && (!list || list.length === 0)) {
    return (
      <div className={styles.blank}>
        <Loading />
      </div>
    );
  }
  //  没有数据
  if (!loading && (!list || list.length === 0)) {
    return (
      <div className={styles.blank}>
        <div className={styles.blank_content}>
          <img alt="" src={nodata} className={styles.blank_img} />
          <div className={styles.blank_link}>
            还没有收藏的专题
            <Link
              className={styles.link}
              to={{
                pathname: `${CONTEXT}/speciallist`,
              }}
            >
              随便逛逛
            </Link>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.special_list}>
      <InfinteScroll
        dataSource={list} // 数据集
        count={pagenation.count}
        minimumBatchSize={10} // 一行最多统一时间加载个数 默认10
        threshold={12} // 预加载个数
        getItemSize={index => (index !== 0 ? 241 : 241)} // 行高
        loadData={loadMore}
        column={3}
        columnWidth={250}
        gap={15}
        template={item => {
          return (
            <div className={classNames(styles.zt_card)}>
              <SpecialCard
                specialInfo={item}
                log={{
                  source: `collection`,
                }}
                handleClick={handleClick}
                hasDelete
                handleDelete={handleDeleteModal(true)}
              />
            </div>
          );
        }}
        tpl={() => <div style={{ height: '0px' }} />}
      />
      {modalVisible && (
        <Dialog
          title="提示"
          maskStyle={styles.mask}
          containerStyle={styles.container}
          handleClose={handleDeleteModal(false)}
        >
          <div className={styles.content}>
            <div className={styles.text}>确认是否要专题从已收藏列表中移除？</div>
            <div className={styles.btn_row}>
              <Btn primary className={styles.btn} handleClick={handleDelete}>
                确定
              </Btn>
              <Btn className={styles.btn} handleClick={handleDeleteModal(false, 'btn')}>
                取消
              </Btn>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};
